module.exports = __webpack_public_path__ + "static/alina-7dc0e6e8e02a433ea70eeb7a871b1b5a.jpg";